import { NeoState } from '~/store';

export const selectCurrentTour = (state: NeoState) => state?.app?.productTours?.activeTour;
export const selectTourRef = (state: NeoState) => state?.app?.productTours?.ref;
